function prefersReducedMotion()
{
	if (window.matchMedia)
	{
		const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
		return motionQuery.matches;
	}
	// If the matchMedia API is not supported, assume no preference for reduced motion
	return false;
}

const counterElements = document.querySelectorAll(".jsCounter");
if (counterElements && prefersReducedMotion() == false)
{
	counterElements.forEach(counter =>
	{
		counter.innerText = counter.dataset.from;
	});
	const totalDuration = 3000; // Total duration for all counters to reach their stop values (in milliseconds)

	// Ease-out function
	function easeOut(t) {
		return 1 - Math.pow(1 - t, 2);
	}

	function counter(target, start, stop) {
		let currentTime = 0;

		function animateCounter() {
			currentTime += 30; // Increment the current time by the interval (30ms)
			const progress = currentTime / totalDuration;
			const easing = easeOut(progress);

			const valueConverted = (start + (stop - start) * easing).toFixed(
				Number.isInteger(stop) ? 0 : 1
			);
			target.innerText = valueConverted;

			if (currentTime < totalDuration) {
				requestAnimationFrame(animateCounter);
			} else {
				// target.innerText = stop.toFixed(Number.isInteger(stop) ? 0 : 1); // Ensure the final value is exact.
				target.innerText = stop.toLocaleString(undefined, {
					useGrouping: true
				});
			}
		}

		requestAnimationFrame(animateCounter);
	}

	function obCallBack(entries) {
		entries.forEach((entry) => {
			const { target } = entry;
			const stopValue = parseFloat(target.dataset.to);
			const startValue = parseFloat(target.dataset.from);
			if (!entry.isIntersecting) return;
			counter(target, startValue, stopValue);
			counterObserver.unobserve(target);
		});
	}

	const counterObserver = new IntersectionObserver(obCallBack, { threshold: 1 });
	counterElements.forEach((counterElem) => counterObserver.observe(counterElem));
}